import { ObjectDetail } from '@/commons/interface/object-detail'
import { ElementFile } from '@/commons/interface/project/info-detail';
import React, { useContext, useEffect, useState } from 'react'
import './object-detail-file.less'
import { Input, Popconfirm, Skeleton } from 'antd';
import { ReactComponent as SearchSvg } from './icons/search.svg'
import { deleteFile, findFiles } from '@/api/project/element';
import dayjs from 'dayjs';
import {
    DownloadOutlined,
    DeleteOutlined
} from '@ant-design/icons';
import { DownloadContext } from '@/App';
import { DownloadState } from 'tncet-common';

interface IProps {
    detail: ObjectDetail
}

export default function ObjectDetailFilePanel(props: IProps) {
    const detail = props.detail;
    const downloadContext = useContext<DownloadState>(DownloadContext);
    const [files, setFiles] = useState<ElementFile[]>([]);
    const [display, setDisplay] = useState<ElementFile[]>([]);
    const [fileHover, setFileHover] = useState<ElementFile>();
    const [loading, setLoading] = useState<boolean>(false);
    const [searchStr, setSearchStr] = useState<string>('');

    const downloadFile = (file: ElementFile) => {
        if (file == null) return;
        console.log(file)
        let dfile = {
            bucketName: "test",
            filename: file.name,
            suffix: file.suffix,
            objectName: file.filePath,
            md5: file.md5,
        }
        downloadContext.startDownload([dfile])
    }

    useEffect(() => {
        if (detail == null) return;
        setLoading(true);
        findFiles(detail.name).then(res => {
            let elefiles = res.data || [];
            setFiles(elefiles);
            filterFiles(elefiles, searchStr)
        }).finally(() => {
            setLoading(false);
        })
    }, [detail])

    const deleteObjectFile = (id: number) => {
        let newFiles = [...files]
        let idx = newFiles.findIndex(item => item.id === id);
        if (idx >= 0) {
            newFiles.splice(idx, 1);
            setFiles(newFiles);
        }
        deleteFile(id).then(res => {

        })
    }



    const filterFiles = (files: ElementFile[], searchStr: string) => {
        if (searchStr.length == 0) {
            setDisplay([...files]);
            return;
        }
        let dis = files.filter(item => item.name.includes(searchStr)) || [];
        setDisplay(dis);
    }

    return (
        <div className='object-detail-file-container'>
            <div className='search-item'>
                <Input className='search-input' prefix={<SearchSvg />} placeholder='搜索文件' value={searchStr} onChange={(e) => {
                    let value = e.target.value;
                    setSearchStr(value);
                    filterFiles(files, value);
                }}/>
            </div>
            <div className='file-list'>
                <Skeleton loading={loading} active>
                    {display.map((file, idx) => (
                        <div className='file-item' key={idx} onMouseEnter={() => setFileHover(file)} onMouseLeave={() => setFileHover(null)}>
                            <div className='file-name ellipsis'>{`${file.name}${file.suffix}`}</div>
                            <div className='file-date'>{dayjs(file.gmtCreate).format('YYYY-MM-DD')}</div>
                            <div className='ope'>
                                {fileHover && fileHover.id == file.id && (
                                    <>
                                        <DownloadOutlined className='icon download-icon' onClick={() => downloadFile(file)} />
                                        <Popconfirm placement='left' title="确认删除" onConfirm={() => {
                                                deleteObjectFile(file.id)
                                            }}>
                                            <DeleteOutlined className='icon download-icon' />
                                        </Popconfirm>
                                    </>
                                )}
                            </div>
                        </div>
                    ))}
                </Skeleton>

            </div>
        </div>
    )
}
